export default __webpack_public_path__ + "static/media/Bebedouro.c6809cf7.svg";